var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8167 11.4429L8.0344 5.62563C8.60627 4.15532 8.28856 2.42931 7.08128 1.2147C5.81045 -0.0638251 3.90421 -0.319531 2.37922 0.38366L5.1115 3.1325L3.20526 5.05029L0.409443 2.30145C-0.353053 3.83569 -0.0353461 5.75348 1.23548 7.03201C2.44276 8.24662 4.15838 8.56625 5.61983 7.99091L11.4021 13.8082C11.6563 14.0639 12.0375 14.0639 12.2917 13.8082L13.7531 12.3379C14.0708 12.0822 14.0708 11.6347 13.8167 11.4429Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanner);
export default __webpack_public_path__ + "static/media/spanner.0404406cb196d7e25707856a1f3cd7f8.svg";
export { ForwardRef as ReactComponent };